export const GET_ADMIN_CALL_ACTIVE_REQUEST = "GET_ADMIN_CALL_ACTIVE_REQUEST";
export const GET_ADMIN_CALL_ACTIVE_SUCCESS = "GET_ADMIN_CALL_ACTIVE_SUCCESS";
export const GET_ADMIN_CALL_ACTIVE_FAIL = "GET_ADMIN_CALL_ACTIVE_FAIL";